export default __webpack_public_path__ + "static/media/Night_Owl_Labor_Day_Sale_Email.64bb3998.jpg";